import { getPallettesByCategoryAndBucket as c } from "@placer-ui/components";
import "@turf/turf";
import "./index.es175.js";
import { rgbArrayToHex as d } from "./index.es277.js";
import "./index.es176.js";
const i = (t, o) => t.paletteColors.map((r, e) => ({
  id: `${t.paletteName}-${e}`,
  value: o[e].toString(),
  color: d(r),
  visible: !0
})), I = (t, o) => {
  const r = c("trade-area", o.length), e = t == null ? void 0 : t.paletteName.split("-").slice(0, 2).join("-"), n = e && r.find((a) => a.paletteName.includes(e));
  if (!n)
    return;
  const l = {
    ...n,
    paletteColors: [...n.paletteColors].reverse()
  }, s = i(l, o);
  return { newSelectedPalette: l, newLegendItems: s };
}, N = ({
  palette: t,
  values: o,
  items: r
}) => o.length !== t.paletteColors.length || !(r && r.every((e, n) => {
  var l;
  return e.value === o[n].toString() && ((l = e == null ? void 0 : e.id) == null ? void 0 : l.includes(t.paletteName));
}));
export {
  i as convertColorPaletteToLegendItems,
  N as isNeedToUpdateColorsOrItemsFilters,
  I as updateColorPaletteAndLegendItems
};
//# sourceMappingURL=index.es66.js.map
